import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";
import Grid from "@material-ui/core/Grid";

import CustomSelect from "../../Common/CustomSelect";

const RecurrenceEvery = (props) => {
  const { classes, formValues, changeParam } = props;

  return (
    <Grid item className={classes.row}>
      <Grid container alignItems="center">
        <Grid item className={classes.label}>
          {I18n.get("scheduler_every")}
        </Grid>
        <Grid item style={{ width: "80px" }}>
          <CustomSelect
            name="every"
            value={get(formValues, ["recurrence", "every"])}
            onChange={(e) => changeParam("every", null, e.target.value)}
            options={map(
              map(new Array(99), (item, index) => index + 1),
              (item) => ({
                id: item,
                name: item.toString(),
              })
            )}
            noSort
          />
        </Grid>
        <Grid item style={{ paddingLeft: "10px" }}>
          {get(formValues, ["recurrence", "repeat"]) === "weekly"
            ? I18n.get("dashboard_weeks")
            : get(formValues, ["recurrence", "repeat"]) === "daily"
              ? I18n.get("scheduler_days")
              : get(formValues, ["recurrence", "repeat"]) === "monthly"
                ? I18n.get("scheduler_months")
                : ""}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RecurrenceEvery;
